const env = process.env.VUE_APP_RUN_ENV // pro,test,dev,proxy,mock;

const baseUrl = {
  dev: 'https://devzmyapi.nfnews.com/nfplus-workmap-api',
  test: 'https://testhdapi.nfnews.com/nfplus-workmap-api',
  pro: 'https://hdapi.nfnews.com/nfplus-workmap-api',
  mock: 'http://localhost:3000',
  proxy: '/api/nanfang_if'
}[env]

const NETWORK_ERR_MSG = '加载失败，请稍后再试'

const UPDATE_VERSION = 610

export { baseUrl, env, UPDATE_VERSION, NETWORK_ERR_MSG }
